import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 1,
  class: "title"
}
const _hoisted_4 = {
  key: 2,
  class: "date"
}
const _hoisted_5 = {
  key: 3,
  class: "description"
}
const _hoisted_6 = {
  key: 4,
  class: "links"
}
const _hoisted_7 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    image_url: $props.image_url,
    imageAlt: $props.title
  }, {
    default: _withCtx(() => [
      ($props.url)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: $props.url,
            target: "_blank",
            class: "title-link"
          }, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString($props.title), 1)
          ], 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString($props.title), 1)),
      ($props.date)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($options.formatDate($props.date)), 1))
        : _createCommentVNode("", true),
      ($props.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.description), 1))
        : _createCommentVNode("", true),
      ($props.category)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString($props.category), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["image_url", "imageAlt"]))
}